import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import {
  getAllEntityFormSettings,
  toggleActive,
  toggleRequired,
  updateOptions,
} from './api'
import { IEntityFormSetting } from './typings'

const entityFormSettingAdapter = createEntityAdapter<IEntityFormSetting>()

export const initialState = entityFormSettingAdapter.getInitialState()

const entityFormSettingSlice = createSlice({
  name: 'entityFormSettingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getAllEntityFormSettings.fulfilled,
      (state, { payload }) => {
        entityFormSettingAdapter.setAll(state, payload)
      },
    )

    builder.addCase(toggleRequired.fulfilled, (state, { payload: id }) => {
      const updatedElement = entityFormSettingAdapter
        .getSelectors()
        .selectById(state, id)
      if (!!updatedElement) {
        entityFormSettingAdapter.updateOne(state, {
          id,
          changes: {
            required: !updatedElement.required,
          },
        })
      }
    })

    builder.addCase(toggleActive.fulfilled, (state, { payload: id }) => {
      const updatedElement = entityFormSettingAdapter
        .getSelectors()
        .selectById(state, id)
      if (!!updatedElement) {
        entityFormSettingAdapter.updateOne(state, {
          id,
          changes: {
            active: !updatedElement.active,
          },
        })
      }
    })

    builder.addCase(
      updateOptions.fulfilled,
      (state, { payload: { options, id } }) => {
        const updatedElement = entityFormSettingAdapter
          .getSelectors()
          .selectById(state, id)
        if (!!updatedElement) {
          entityFormSettingAdapter.updateOne(state, {
            id,
            changes: {
              options: options,
            },
          })
        }
      },
    )
  },
})

export default entityFormSettingSlice.reducer

const entityFormSettingSelecters =
  entityFormSettingAdapter.getSelectors<StoreData>(
    (state) => state.entityFormSettings,
  )

export const {
  selectAll: selectAllEntityFormSettings,
  selectById: selectEntiyFormSettingById,
} = entityFormSettingSelecters
